import { Field, ObjectType } from 'type-graphql'
import { Product } from '../product/Product'
import { CompareData } from './CompareData'
import type { QbProductsCompareDataKindEnum } from './QbProductsCompareDataKindEnum'

@ObjectType()
export class QbProductsCompareData extends CompareData {
  @Field(() => Product)
  qbProduct: Product

  @Field(() => Product)
  dbProduct: Product

  @Field(() => String)
  qbProductsCompareDataKind: QbProductsCompareDataKindEnum
}
